import axios from "axios";

export default {
  namespaced: true,
  state: {
    prices: [],
    images: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    pricesMessage: ''
  },
  mutations: {
    RECEIVED_PRICES(state, payload) {
      state.prices = payload;
      state.isReceiving = false;
    },
    RECEIVING_PRICES(state) {
      state.isReceiving = true;
    },
    RECEIVED_PRICE(state, payload) {
      console.log("RECEIVED PRICE", payload);
      state = Object.assign(state, {
        prices: [...state.prices, payload],
        isReceiving: false,
      })
    },
    RECEIVING_PRICE(state) {
      state.isReceiving = true;
    },
    UPDATED_PRICE(state, payload) {
      console.log(state.prices);
      console.log(payload);
      let index = state.prices.findIndex(price => price._id === payload._id);
      state = Object.assign(state, {
        prices: state.prices.map((price, i) => {
          if (i === index) {
            return Object.assign({}, price, payload);
          }
          return price;
        }),
        isUpdating: false,
        pricesMessage: 'Prices has been updating!',
      })
    },
    UPDATING_PRICE(state) {
      state.isUpdating = true;
    },
    DELETED_PRICE(state, payload) {
      console.log("DELETE", payload);
      let indexToDelete = state.prices.findIndex(price => price._id === payload._id);
      console.log(indexToDelete);
      let prices = [...state.prices];
      prices.splice(indexToDelete, 1);
      state = Object.assign(state, {
        prices: [...prices],
        isDeleting: false,
        idToDelete: null,
        pricesMessage: 'Price has been Deleted!',
      });
    },
    DELETING_PRICE(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    getPricesRequest({dispatch}) {
      dispatch("receivingPrices");
      var token = localStorage.getItem('token');
      var url = 'https://api.accountxc.com:3100/get/prices';
      var header = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      };
      var get = {
        method: "get",
        url: url,
        headers: header,
      };
      axios(get).then(res => {
        dispatch("receivePrices", res.data);
      })
    },
    async updatePriceRequest({dispatch}, payload) {
      dispatch("updatingPrice");
      let id = payload._id;
      delete payload['_id'];
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/update/price/' + id;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};
      let response = await axios({method: "put", url: url, headers: headers, data: payload});
      dispatch("updatePrice", response.data);
      return response.data;
    },
    async updateFocRequest({dispatch}, payload) {
      dispatch("updatingPrice");
      let id = payload._id;
      delete payload['_id'];
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/update/price/foc/' + id;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};
      let response = await axios({method: "put", url: url, headers: headers, data: payload});
      dispatch("updatePrice", response.data);
      return response.data;
    },
    updatePriceImageRequest({dispatch}, payload) {
      dispatch("updatingPrice");
      var data;
      var header;
      var token = localStorage.getItem('token');
      var id = payload._id;
      delete payload['_id'];
      console.log(id, payload);

      var url = 'https://api.accountxc.com:3100/update/price/image/' + id;
      data = new FormData();
      data.append('image', payload.priceimage, payload.imagename); 
      delete payload['priceimage'];
      for (let x in payload) {
        data.append(x, payload[x]);
      }
      header = {
        'Content-Type': 'multipart/form-data',
        'Authorization': 'Bearer ' + token
      };

      var post = {
        method: "post",
        url: url,
        headers: header,
        data: data,
      };

      axios(post)
      .then(function (res) {
        console.log(res);
        dispatch("updatePrice", res.data);
      })
      .catch((error) => {
        console.error('Error:', error);
        this.alertmessage = error;
      });
    },
    createPriceRequest({dispatch}, payload) {
      dispatch("receivingPrices");
      var url;
      var data;
      var header;
      var token = localStorage.getItem('token');

      if(payload.priceimage !== undefined) {
        url = 'https://api.accountxc.com:3100/insert/price/withimage';
        data = new FormData();
        data.append('image', payload.priceimage, payload.imagename); 
        delete payload['priceimage'];
        for (let x in payload) {
          data.append(x, payload[x]);
        }
        header = {
          'Content-Type': 'multipart/form-data',
          'Authorization': 'Bearer ' + token
        };
      } else {
        url = 'https://api.accountxc.com:3100/insert/price';
        data = payload;
        header = {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
        };
      }
      var post = {
        method: "post",
        url: url,
        headers: header,
        data: data,
      };
      axios(post)
      .then(function (res) {
        console.log(res);
        dispatch("receivePrice", res.data);
      })
      .catch((error) => {
        console.error('Error:', error);
        this.alertmessage = error;
      });	
    },
    async insertPriceRequest({dispatch}, payload) {
      dispatch("receivingPrices");
      let token = localStorage.getItem('token');
      var id = payload.pricelistid;
      delete payload['pricelistid'];
      let url = 'https://api.accountxc.com:3100/insert/price/' + id;
      let data = payload;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      let response = await axios({method: "post", url: url,headers: headers, data: data})
      dispatch("receivePrice", response.data);
      return response.data;
    },
    async deletePriceRequest({dispatch}, payload) {
      dispatch("deletingPrice", payload);
      let token = localStorage.getItem('token')
      let url = 'https://api.accountxc.com:3100/delete/price/' + payload._id;
      var header = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};

      let response =  await axios({method: "delete",url: url,headers: header})
      dispatch("deletePrice", response.data);
      return response.data;
    },
    receivePrices({commit}, payload) {
      commit("RECEIVED_PRICES", payload)
    },
    receivingPrices({commit}) {
      commit("RECEIVING_PRICES")
    },
    receivePrice({commit}, payload) {
      console.log("HERE");
      console.log(payload);
      commit("RECEIVED_PRICE", payload)
    },
    receivingPrice({commit}) {
      commit("RECEIVING_PRICE")
    },
    updatePrice({commit}, payload) {
      commit("UPDATED_PRICE", payload)
    },
    updatingPrice({commit}) {
      commit("UPDATING_PRICE")
    },
    deletePrice({commit}, payload) {
      console.log(payload);
      commit("DELETED_PRICE", payload)
    },
    deletingPrice({commit}, payload) {
      commit("DELETING_PRICE", payload)
    }
  },
};
